export const convertMmTo = ({ round, value, unit }) => {
  let returnValue;

  switch (unit) {
    case 'in':
      returnValue = parseFloat(value) / 25.4;
      break;
    case 'ft':
      returnValue = parseFloat(value) / 25.4 / 12;
      break;
    default:
      returnValue = value;
      break;
  }

  return round ? Math.round(returnValue) : returnValue;
};

export const convertToMm = ({ round, value, unit }) => {
  let returnValue;

  switch (unit) {
    case 'in':
      returnValue = parseFloat(value) * 25.4;
      break;
    case 'ft':
      returnValue = parseFloat(value) * 25.4 * 12;
      break;
    default:
      returnValue = value;
      break;
  }

  return round ? Math.round(returnValue) : returnValue;
};

export const convertDimensionsForAPI = ({ enabledFilters, selectedSizeUnit }) => {
  let Width = enabledFilters['Width'];
  let Height = enabledFilters['Height'];
  let Depth = enabledFilters['Depth'];

  if (enabledFilters['Width'] && enabledFilters['Width'].length > 0) {
    Width = [convertToMm({ round: true, value: enabledFilters['Width'][0], unit: selectedSizeUnit })];
  }
  if (enabledFilters['Height'] && enabledFilters['Height'].length > 0) {
    Height = [convertToMm({ round: true, value: enabledFilters['Height'][0], unit: selectedSizeUnit })];
  }
  if (enabledFilters['Depth'] && enabledFilters['Depth'].length > 0) {
    Depth = [convertToMm({ round: true, value: enabledFilters['Depth'][0], unit: selectedSizeUnit })];
  }

  return [Width, Height, Depth];
};
